import React, { PropTypes } from 'react';
import {FormattedMessage} from 'react-intl';
import s from './ConfirmSignUp.scss';
import {Link} from 'react-router';


class ConfirmSignUp extends React.Component {
  static propTypes = {
    success: PropTypes.bool.isRequired
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  componentWillMount() {
    const {phoneComponent, phoneScreenUrl} = this.context.muiTheme.nonLogged;
    this.phoneComponent = React.cloneElement(phoneComponent, {
      children: (<img src={phoneScreenUrl} className={s.appScrean}/>),
      hideOverflow: true
    });
  }

  render() {
    const {success} = this.props;

    return (
      <div className={s.root}>
        <div className={s.phone}>
          {this.phoneComponent}
        </div>
        {
          success
            ? (
            <div className={s.message}>
              <h1><FormattedMessage
                id="sign-up.success-title"
                defaultMessage="Welcome!"/></h1>

              <div>
                <FormattedMessage
                  id="sign-up.success-message"
                  defaultMessage="Your mail is correctly confirmed! Enjoy your LiVE! experience!"
                />
              </div>

              <br/>

              <Link to="/login">
                <FormattedMessage
                  id="sign-up.login-link"
                  defaultMessage="Please, login"
                />
              </Link>
            </div>
          )
            : (
            <div className={s.message}>
              <h1><FormattedMessage
                id="sign-up.sorry-title"
                defaultMessage="We are sorry!"/></h1>

              <FormattedMessage
                id="sign-up.sorry-message"
                defaultMessage="There was a problem with your account verification. Please try again or contact your LIVE! product manager for assistance."
              />
            </div>
          )
        }
      </div>
    );
  }
}

export default ConfirmSignUp;





// WEBPACK FOOTER //
// ./src/components/ConfirmSignUp/ConfirmSignUp.js